import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

/**
 * Campo de digitação da mensagem do "paciente" no simulador.
 */
function SimulatorComposer({ onSend, disabled }) {
  const [text, setText] = useState("");

  const handleSend = () => {
    if (text.trim() === "" || disabled) return;
    onSend(text);
    setText("");
  };

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="Escreva como se fosse o paciente..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        }}
      />
      <Button
        variant="contained"
        disabled={disabled || text.trim() === ""}
        style={{
          backgroundColor: disabled || text.trim() === "" ? undefined : "var(--color-secondary, #ED3680)",
          color: disabled || text.trim() === "" ? undefined : "#fff",
          textTransform: "none",
          borderRadius: "8px",
          height: "40px",
        }}
        startIcon={<SendIcon />}
        onClick={handleSend}
      >
        Enviar
      </Button>
    </>
  );
}

export default SimulatorComposer;
